import { DEFAULT_PRE_SERVICES } from '@root/src/types';
import { createFileValidationSchema } from '@utils/fileValidation';
import yup from '@services/translation/translatedYup';
import { VIP_VALIDATION_INPUT } from '@features/ui-input/components/InputVIP';
import { DEFAULT_PRE_SERVICES_INPUT } from '@features/carts/components/OrderItemResume/DefaultPreServiceUpdateForm';

const preServicesSchemaFactory = (fieldType: DEFAULT_PRE_SERVICES | DEFAULT_PRE_SERVICES_INPUT, t) => {
  switch (fieldType) {
    case DEFAULT_PRE_SERVICES.CLUB:
    case DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER:
    case DEFAULT_PRE_SERVICES.LICENSE:
      return yup.string();
    case DEFAULT_PRE_SERVICES.INSURANCE:
      return yup.boolean()
        .test(DEFAULT_PRE_SERVICES.INSURANCE, ' ', (value, context) => (value ? context.parent.insuranceAcceptance : true));
    case DEFAULT_PRE_SERVICES.CLUB_MANDATORY:
    case DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER_MANDATORY:
    case DEFAULT_PRE_SERVICES.LICENSE_MANDATORY:
      return yup.string().required();
    case DEFAULT_PRE_SERVICES.VIP:
      return yup.string().required(t('InputVIP_required.message'))
        .test(VIP_VALIDATION_INPUT.VIP_IS_VALID, (value, context) => {
          if (context.parent[VIP_VALIDATION_INPUT.VIP_IS_VALID]) {
            return true;
          }
          return context.createError({
            path: context.path,
            message: context.parent[VIP_VALIDATION_INPUT.VIP_ERROR],
          });
        });
    case DEFAULT_PRE_SERVICES.FILE_UPLOAD_MANDATORY:
      return createFileValidationSchema(t, 10);
    default:
      return yup.mixed();
  }
};

export default preServicesSchemaFactory;

export const generatePreServicesSchema = (preServicesProps, t) => preServicesProps
  .map(preServiceProp => ({ [preServiceProp.name]: preServicesSchemaFactory(preServiceProp.key, t) }))
  .reduce((a, b) => ({
    ...a,
    ...b,
  }), {});
